import React from 'react'
import { useTrans } from 'hooks'
import { dateNotation, dateNotationSeo, getImageUrl } from 'utils/safe'
import { mockArray, mockArticoloCard, mockProdottoCardFinal } from 'utils/mock'
import { Vector1, Vector6 } from 'components/atoms/Icons'
import { ImageBox, SocialShare } from 'components/atoms'
import { PlaceholderReact } from 'components/molecules'
import { Page, ProdottiCorrelati, ArticoliCorrelati } from 'components/organisms'
import Head from 'next/head'
import { DOMAIN } from 'utils/settings'
import { useRouter } from 'next/router'

interface Props {
  articolo: {
    pk: number
    contentTypeId: number
    titolo: string
    sottotitolo: string
    testo: string
    url: string
    data: string
    modified: string
    mainImage: string
    categoria: {
      nome: string
    }
    breadcrumbs: {
      titolo: string
      url: string
    }[]
    prodottiCorrelati: any[]
    newsCorrelate: any[]
  }
  pagina: any
}

const ArticoloTemplate = (props: Props) => {
  const { articolo = null, pagina = {} } = props
  const router = useRouter()

  const t = useTrans()

  const jsonLd = {
    '@context': 'http://schema.org',
    '@type': 'Article',
    'headline': articolo.titolo,
    'image': articolo?.mainImage ? [articolo?.mainImage] : [],
    'author': {
      '@type': 'Organization',
      'name': 'Vinicum',
    },
  }
  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      </Head>
      <Page
        item={articolo}
        pagina={pagina}
        topBg="left"
        customContent={
          <>
            {!!articolo.categoria?.nome && (
              <p className="articolo-template__category">{articolo.categoria?.nome}</p>
            )}
            <h1 className="articolo-template__title">{articolo.titolo}</h1>
            <div className="articolo-template__description">{articolo.sottotitolo}</div>
            <p className="articolo-template__date">{dateNotation(articolo.data)}</p>
            <svg height="0" width="0">
              <defs>
                <clipPath id="hero-clip">
                  <path d="M210.25 57.21C348.229 48.8173 487.837 -67.2089 612.877 57.21C737.917 181.629 680.217 396.108 485.372 474.978C347.435 530.812 45.5106 423.689 7.87982 274.486C-29.751 125.284 72.2703 65.6026 210.25 57.21Z" />
                </clipPath>
              </defs>
            </svg>
            <div className="articolo-template__image-wrap">
              <ImageBox
                src={articolo.mainImage ? articolo.mainImage : null}
                maxWidth={680}
                maxHeight={490}
                layout="intrinsic"
                objectFit="cover"
                classPrefix="articolo-template"
              />
            </div>
          </>
        }
        className="articolo-template"
      >
        <div className="articolo-template__vector-left">
          <Vector1 />
        </div>
        <div className="articolo-template__vector-right">
          <Vector6 />
        </div>
        <div className="articolo-template__layout">
          <div className="articolo-template__main">
            {articolo.testo && (
              <div
                className="articolo-template__text legacy-text"
                dangerouslySetInnerHTML={{ __html: articolo.testo }}
              />
            )}
            <div className="articolo-template__content">
              <PlaceholderReact
                contentTypeId={articolo.contentTypeId}
                objectId={articolo.pk}
                pkey="content"
              />
            </div>
            <SocialShare className="articolo-template__social-share" />
          </div>
          <div className="articolo-template__sidebar">
            {articolo.prodottiCorrelati?.length > 0 && (
              <ProdottiCorrelati
                title={t('Lasciati ispirare')}
                prodotti={articolo.prodottiCorrelati.slice(0, 3)}
                desktopColumn
                className="articolo-template__prodotti-correlati"
              />
            )}
          </div>
        </div>
        <ArticoliCorrelati
          articoli={articolo.newsCorrelate}
          title={t('Leggi altri racconti')}
          className="articolo-template__articoli-correlati"
        />
      </Page>
    </>
  )
}

export default ArticoloTemplate
